import {Component} from '@angular/core';
import {
	EntitySelectComponent,
	BaseModel,
	BaseModelInterface,
} from '@app/abstracts';
import {ErrorService} from '@app/services';
import {MarkerSearchParams} from '../marker-search-params';
import {MarkerService} from '../marker.service';
import {Marker} from '../marker';
import { QuickFormService } from '../../../plugins/quick-form';
@Component({
  selector: 'hpf-marker-select',
  templateUrl: '../../../abstracts/entity-select/entity-select.component.html'
})
export class MarkerSelectComponent extends EntitySelectComponent< Marker> {
  protected modelName = 'marker';
  /**
   * Constructor
   * @param {MarkerService} markerService
   * @param {ErrorService} errorService
   */
  constructor(private markerService: MarkerService,
              protected errorService: ErrorService,
              protected quickFormService: QuickFormService) {
    super(errorService, quickFormService);
  }
  ngOnInit() {
		super.ngOnInit();
    // Refresh model in case of creation by quick form
		this.subscriptions.push(
			this.quickFormService.refresh.subscribe(
				(model: BaseModel<BaseModelInterface, {}>) => {
					if(!(model instanceof Marker)) return;
          if(this.multiple) {
            if (!this.model) this.model = [];
            (<Marker[]>this.model).push(<Marker>model);
          } else {
            this.model = <Marker>model;
          }
          this.refresh();
				}
			)
		);
	}
  /** @inheritDoc */
  protected async getList(): Promise< Marker[]> {
      const params = new MarkerSearchParams({
          _limit: this.resultsLimit,
          _page: this.currentPage
      });
      return (await this.markerService.list(params.toObject())).items;
  }
  /** @inheritDoc */
  protected async getOne(id: string): Promise< Marker> {
      return await this.markerService.get(id);
  }
}
